import { render, staticRenderFns } from "./templates-inputs-resizer.vue?vue&type=template&id=5d5d3d4e&scoped=true&lang=pug"
import script from "./templates-inputs-resizer.vue?vue&type=script&lang=js"
export * from "./templates-inputs-resizer.vue?vue&type=script&lang=js"
import style0 from "./templates-inputs-resizer.vue?vue&type=style&index=0&id=5d5d3d4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d3d4e",
  null
  
)

export default component.exports